import ApiServices, {CHANGE_CURRENT_MERCHANT} from "../config/ApiServices";
import api from "../utils/api";
import store from "../store";
import {resetMerchant} from "../store/merchant";
import {HIDE_CHANGE_MERCHANT_POPUP} from "../config/event";
import {sleep} from "../utils/functions";

export class ChangeCurrentMerchantEvent {
    params = {};

    constructor(params = null) {
        this.params = params;
    }

    static getEventName() {
        return 'ChangeCurrentMerchantEvent';
    }
}

export class ChangeCurrentMerchantEventListener {
    dispatcher;

    constructor(dispatcher = null) {
        this.dispatcher = dispatcher;
    }

    async handle(event) {
        let apiServices = ApiServices;
        let res = await api(apiServices[CHANGE_CURRENT_MERCHANT]['apiName'], event.params);
        if (res['status']) {
            return res;
        }
    }

    async after(event) {
        this.dispatcher.dispatch(HIDE_CHANGE_MERCHANT_POPUP);
        let token = event['result']['meta']['token'];
        global.router.history.push({
            search: "refresh_time=" + Date.now() + '&token=' + token['value'] + '&ttl=' + token['ttl'] + '&refresh_ttl=' + token['refresh_ttl']
        });
        await sleep(0.1);
        store.dispatch(resetMerchant());
    }
}